import AuthStorage from './AuthStorage';
import { Router } from 'src/routes';

export default function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const init = () => (!AuthStorage.isAdmin && Router.pushRoute('/'));
export const lockEmployeesTools = (id) => (AuthStorage.role === 'ROLE_EMPLOYEE' && AuthStorage.id !== id);

export const AUTH_COMPANY_RESTAURANT_R_GROUP_MAIN = 'auth comp restaurant restaurantGroup main';
export const AUTH_MAIN = 'auth main';
export const AUTH_COMP_MAIN = 'auth com main';
export const AUTH_RESTAURANT_R_GROUP_MAIN = 'auth restaurant restaurantGroup main';
export const AUTH_COMPAMY_RESTAURANT_EMPLOYE_R_GROUP_MAIN = 'auth comp restaurant emp restaurantGroup main';
export const AUTH_COMPAMY_EMPLOYE_RESTAURANT_R_GROUP_MAIN = 'auth comp emp restaurant restaurantGroup main';
